export const UA = window.navigator.userAgent;
export const APP_VERSION = (UA.match(/ver:([0-9.]+)/) || [])[1];
export const IS_ANDROID = UA.includes('client:android');
export const IS_IOS = UA.includes('client:ios');
export const IS_TURBO = UA.includes('Turbo Native');
export const IS_MOBILE = IS_ANDROID || IS_IOS;
